<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 OS-m — Emissão: Nova
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  emitir uma Ordem de Serviço nova
        |  vinculada a um
        strong  cadastro
        |  (imobiliário, mobiliário etc.), pelo menu
        strong  OS-m → Serviços
        | .

      .toast.toast-primary
        | A opção
        strong  Nova
        |  só aparece se o seu usuário tiver a permissão
        strong  Ordem serviços → Criar
        | .

      h5.h5 1. Abrir o formulário
      ol
        li Em
          strong  OS-m → Serviços
          | , clique no botão
          strong  +
          |  (Novo serviço).
        li No menu, escolha
          strong  Nova
          | .
      figure.manual-figure
        img(:src="imgMenu" alt="Menu + com opções de emissão de OS")

      h5.h5 2. Preencher a Nova OS
      figure.manual-figure
        img(:src="imgForm" alt="Formulário Nova OS")
      p Campos principais:
      ol
        li
          strong Assunto
          |  (obrigatório) — selecione o assunto da OS.
        li
          strong Situação
          |  — ex.: Em Abertura, Em andamento.
        li
          strong Fiscal
          |  — responsável pela OS.
        li
          strong Analista
          |  — aparece somente se o assunto permitir análise.
        li
          strong Vincular documento
          |  (opcional) — associa um Doc de origem.
        li
          strong Cadastro
          |  (obrigatório) — escolha o cadastro vinculado.
        li
          strong Endereço
          |  — por padrão usa o do cadastro; se faltarem coordenadas,
          |  o sistema avisa e você pode completar; também é possível
          |  informar um endereço diferente.
        li
          strong Protocolo
          |  — tipo, número, ano e data.
        li
          strong Prazo
          |  e, se necessário, ative
          strong  É necessário agendar
          | .
        li
          strong Observações
          |  e, conforme o assunto, o
          strong  checklist extra
          | .

      h5.h5 3. Salvar
      ol
        li Clique em
          strong  Salvar
          |  (habilitado quando o formulário estiver válido).
        li O sistema exibe a mensagem de sucesso e abre a OS criada
          |  (tela de exibição).

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgMenu: require("@/assets/manuais/06-osm-emissao-menu.png"),
      imgForm: require("@/assets/manuais/06a-osm-emissao-nova.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
